import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {ContractLinkSummaries} from '../models/contract-link';
import {linkContractActionTypes, LoadLinkContractSuccessAction, LoadLinkContractUpdateCompanyNameAction} from '../actions/contract-link';
import * as moment from 'moment';


export interface ContractLinkState {
  array: ContractLinkSummaries[];
  companyUuid: string;
}

const initialState: ContractLinkState = {
  array: [],
  companyUuid: undefined
};

export function ContractLinkReducer(state: ContractLinkState = initialState, action: Action): ContractLinkState {
  switch (action.type) {
    // case linkContractActionTypes.LOAD:
    //   return handleLoadAction();
    case linkContractActionTypes.UPDATE_COMPANY_NAME:
      return handleUpdateCompanyNameAction(state, action);
    case linkContractActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case linkContractActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleUpdateCompanyNameAction(state: ContractLinkState, action: LoadLinkContractUpdateCompanyNameAction): ContractLinkState {
  const newState = _.clone(state);
  newState.companyUuid = action.payload;
  if (newState.array && newState.array.length > 0) {
    // tslint:disable-next-line:no-any
    const contractListArray: any[] = [];
    // tslint:disable-next-line:no-any
    const contractListArray2: any[] = [];
    if (newState.array.length > 0) {
      // tslint:disable-next-line:no-any
      newState.array.forEach( function ( item: any, i: number): void {
        if (newState.companyUuid === item.companyUuid) {
          contractListArray.push(Object.assign({},
            {contractName: item.contractName},
            {contractUuid: item.contractUuid},
            {companyName: item.companyNameOrigin},
            {companyNameOrigin: item.companyNameOrigin},
            {productName: item.productName},
            {productID: item.productID},
            {end: item.end},
            {start: item.start},
            {currentPrice: item.currentPrice},
          ))
        } else {
          contractListArray2.push(Object.assign({},
            {contractName: item.contractName},
            {contractUuid: item.contractUuid},
            {companyName: 'Others'},
            {companyNameOrigin: item.companyNameOrigin},
            {productName: item.productName},
            {productID: item.productID},
            {end: item.end},
            {start: item.start},
            {currentPrice: item.currentPrice },
          ))
        }
      });
    }
    newState.array =  [ ...contractListArray, ...contractListArray2];
  }
  return newState;
}

function handleLoadSuccess(state: ContractLinkState, action: LoadLinkContractSuccessAction): ContractLinkState {
  const newState = _.clone(state);
  const payload = _.clone(action.payload);
  // tslint:disable-next-line:no-any
  const contractListArray: any[] = [];
  // tslint:disable-next-line:no-any
  const contractListArray2: any[] = [];

  if (payload.length > 0) {
    payload.forEach( function ( item: ContractLinkSummaries, i: number): void {
      if (newState.companyUuid === item.companyUuid) {
        contractListArray.push(Object.assign({},
        {contractName: item.name},
        {contractUuid: item.uuid},
        {companyName: item.companyName},
        {companyNameOrigin: item.companyName},
        {companyUuid: item.companyUuid},
        {productName: item.productName},
        {productID: item.productID},
        {end: moment(item.end).format('DD/MM/YYYY')},
        {start: moment(item.start).format('DD/MM/YYYY')},
        {currentPrice: item.currentPrice !== null ? item.currentPrice + ' €' : ''},
        ))
      } else {
        contractListArray2.push(Object.assign({},
          {contractName: item.name},
          {contractUuid: item.uuid},
          {companyName: 'Others'},
          {companyNameOrigin: item.companyName},
          {productName: item.productName},
          {companyUuid: item.companyUuid},
          {productID: item.productID},
          {end: moment(item.end).format('DD/MM/YYYY')},
          {start: moment(item.start).format('DD/MM/YYYY')},
          {currentPrice: item.currentPrice !== null ? item.currentPrice + ' €' : ''},
        ))
      }
    });
  }
  newState.array =  [ ...contractListArray, ...contractListArray2];
  return newState;
}

function handleLoadFailAction(state: ContractLinkState): ContractLinkState {
  const newState = _.clone(state);
  newState.array = [];
  newState.companyUuid = undefined;
  return newState;
}

export const contractLinkSelectors = {
  array: (state: ContractLinkState) => _.get(state, 'array', []),
  companyUuid: (state: ContractLinkState) => _.get(state, 'companyUuid'),
};
